import MySessionTable from "./MySessionTable";
import { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";
import handleApiError from "../../utils/handleError";
import { Loading } from "../../components";
import "./mySession.css";
import Timer from "./Timer";
import moment from "moment";

export default function MySession() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [initialTimeStamp, setInitialTimeStamp] = useState(0);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res: any = await axiosClient.get("examinstances/user/scheduled");
        if (res.data?.length) {
          const sortedExams = res.data.sort(
            (a: any, b: any) => a.time - b.time
          );
          setData(sortedExams);

          const upcomingExams = sortedExams.filter((exam: any) =>
            moment.unix(exam.time).isAfter(moment())
          );

          // If there are upcoming exams, find the one with the earliest time
          if (upcomingExams.length > 0) {
            const nextExam = upcomingExams[0];
            setInitialTimeStamp(nextExam.time);
          }
        }
        // setInitialTimeStamp(moment().add("1", "M").unix());
      } catch (error) {
        handleApiError(error);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {loading ? <Loading /> : null}
      {initialTimeStamp ? <Timer initialTimeStamp={initialTimeStamp} /> : null}

      <h5 className="my-session-heading">My Sessions</h5>
      <MySessionTable data={data} />
    </div>
  );
}
